import React, { useEffect, useState } from 'react';

const Spinner = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return loading ? (
    <div className="show w-100 vh-100 bg-white position-fixed translate-middle top-50 start-50 d-flex align-items-center justify-content-center" style={{ zIndex: 9999 }}>
      <div className="spinner-grow text-primary" role="status"></div>
    </div>
  ) : null;
};

export default Spinner;